import { transparentize as e } from "polished";
import { palette as n, uiColors as r } from "@leafygreen-ui/palette";
import t, { createContext as o, useContext as i, useRef as a, useCallback as l, useEffect as s, useMemo as c, useState as d } from "react";
import u from "prop-types";
import { css as p, cx as f } from "@leafygreen-ui/emotion";
import { usePrevious as g, useIdAllocator as h, useViewportSize as m, useEventListener as b } from "@leafygreen-ui/hooks";
import { createDataProp as v, isComponentType as y, consoleOnce as x, keyMap as w } from "@leafygreen-ui/lib";
import { fontFamilies as O, breakpoints as k, spacing as N } from "@leafygreen-ui/tokens";
import { Label as S, Description as C } from "@leafygreen-ui/typography";
import j, { Align as D, Justify as I } from "@leafygreen-ui/popover";
import { useUsingKeyboardContext as E } from "@leafygreen-ui/leafygreen-provider";
import P from "@leafygreen-ui/icon/dist/Checkmark";
import { jsx as _ } from "@emotion/react";
import { isFragment as z } from "react-is";
import H, { Size as A, Variant as M } from "@leafygreen-ui/button";
import T from "@leafygreen-ui/icon/dist/CaretDown";
import G from "@leafygreen-ui/icon/dist/Warning";

function L(e, n) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), r.push.apply(r, t);
  }

  return r;
}

function R(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = null != arguments[n] ? arguments[n] : {};
    n % 2 ? L(Object(r), !0).forEach(function (n) {
      F(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : L(Object(r)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }

  return e;
}

function F(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}

function V() {
  return V = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var t in r) {
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
      }
    }

    return e;
  }, V.apply(this, arguments);
}

function B(e, n) {
  if (null == e) return {};

  var r,
      t,
      o = function (e, n) {
    if (null == e) return {};
    var r,
        t,
        o = {},
        i = Object.keys(e);

    for (t = 0; t < i.length; t++) {
      r = i[t], n.indexOf(r) >= 0 || (o[r] = e[r]);
    }

    return o;
  }(e, n);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (t = 0; t < i.length; t++) {
      r = i[t], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
  }

  return o;
}

function K(e, n) {
  return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(n)
    }
  }));
}

function X(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == r) return;
    var t,
        o,
        i = [],
        a = !0,
        l = !1;

    try {
      for (r = r.call(e); !(a = (t = r.next()).done) && (i.push(t.value), !n || i.length !== n); a = !0) {
        ;
      }
    } catch (e) {
      l = !0, o = e;
    } finally {
      try {
        a || null == r.return || r.return();
      } finally {
        if (l) throw o;
      }
    }

    return i;
  }(e, n) || q(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function Z(e) {
  return function (e) {
    if (Array.isArray(e)) return Y(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || q(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function q(e, n) {
  if (e) {
    if ("string" == typeof e) return Y(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Y(e, n) : void 0;
  }
}

function Y(e, n) {
  (null == n || n > e.length) && (n = e.length);

  for (var r = 0, t = new Array(n); r < n; r++) {
    t[r] = e[r];
  }

  return t;
}

var U,
    W,
    $,
    J,
    Q,
    ee,
    ne,
    re,
    te,
    oe,
    ie,
    ae,
    le,
    se,
    ce,
    de,
    ue,
    pe,
    fe,
    ge,
    he,
    me = "dark",
    be = "light",
    ve = (F(U = {}, be, {
  text: {
    deselected: n.gray.dark1
  },
  menu: {
    border: n.gray.light2,
    shadow: e(.75, n.black)
  },
  option: {
    group: {
      label: n.gray.dark1,
      border: n.white
    },
    background: {
      base: n.white,
      hovered: n.gray.light2,
      focused: n.blue.light3
    },
    text: {
      base: n.gray.dark3,
      selected: n.blue.base,
      disabled: n.gray.base,
      focused: n.blue.dark2
    },
    icon: {
      base: n.gray.dark1,
      selected: n.blue.base,
      disabled: n.gray.base
    },
    indicator: {
      focused: n.blue.base
    }
  }
}), F(U, me, {
  text: {
    deselected: r.gray.light1
  },
  menu: {
    shadow: e(.2, r.black)
  },
  option: {
    group: {
      label: r.gray.light1,
      border: r.gray.dark1
    },
    background: {
      base: r.gray.dark2,
      hovered: r.gray.dark1,
      focused: r.blue.base
    },
    text: {
      base: r.white,
      selected: "#9DD0E7",
      disabled: r.gray.base,
      focused: r.white
    },
    icon: {
      base: r.gray.light1,
      selected: "#9DD0E7",
      disabled: r.gray.base
    },
    indicator: {
      focused: r.white
    }
  }
}), U),
    ye = {
  XSmall: "xsmall",
  Small: "small",
  Default: "default",
  Large: "large"
},
    xe = (F(W = {}, ye.XSmall, {
  height: 22,
  text: 13,
  lineHeight: 20,
  option: {
    text: 13
  },
  warningIcon: 16
}), F(W, ye.Small, {
  height: 28,
  text: 13,
  lineHeight: 20,
  option: {
    text: 13
  },
  warningIcon: 16
}), F(W, ye.Default, {
  height: 36,
  text: 13,
  lineHeight: 20,
  option: {
    text: 13
  },
  warningIcon: 16
}), F(W, ye.Large, {
  height: 48,
  text: 18,
  lineHeight: 22,
  option: {
    text: 16
  },
  warningIcon: 16
}), W),
    we = (F($ = {}, ye.XSmall, {
  height: 22,
  text: 12,
  option: {
    text: 14
  },
  warningIcon: 12,
  label: {
    text: 14,
    lineHeight: 16
  },
  description: {
    text: 14,
    lineHeight: 16
  }
}), F($, ye.Small, {
  height: 28,
  text: 14,
  option: {
    text: 14
  },
  warningIcon: 14,
  label: {
    text: 14,
    lineHeight: 16
  },
  description: {
    text: 14,
    lineHeight: 16
  }
}), F($, ye.Default, {
  height: 36,
  text: 14,
  option: {
    text: 14
  },
  warningIcon: 14,
  label: {
    text: 14,
    lineHeight: 16
  },
  description: {
    text: 14,
    lineHeight: 20
  }
}), F($, ye.Large, {
  height: 48,
  text: 18,
  option: {
    text: 16
  },
  warningIcon: 17.5,
  label: {
    text: 18,
    lineHeight: 21
  },
  description: {
    text: 18,
    lineHeight: 24
  }
}), $),
    Oe = 36,
    ke = 16,
    Ne = {
  text: 16,
  lineHeight: 19
},
    Se = {
  text: 16,
  lineHeight: 22
},
    Ce = {
  text: 16
},
    je = {
  None: "none",
  Error: "error"
},
    De = o({
  mode: be,
  size: ye.Default,
  open: !1,
  disabled: !1
}),
    Ie = v("option"),
    Ee = p(J || (J = K(["\n  display: flex;\n  width: 100%;\n  outline: none;\n  overflow-wrap: anywhere;\n  transition: background-color 150ms ease-in-out;\n  position: relative;\n  padding: 8px 12px;\n\n  &:before {\n    content: '';\n    position: absolute;\n    transform: scaleY(0.3);\n    top: 7px;\n    bottom: 7px;\n    left: 0;\n    right: 0;\n    width: 4px;\n    border-radius: 0px 4px 4px 0px;\n    opacity: 0;\n    transition: all 150ms ease-in-out;\n  }\n"]))),
    Pe = p(Q || (Q = K(["\n  display: flex;\n  align-items: center;\n  font-family: ", ";\n"])), O.default),
    _e = p(ee || (ee = K(["\n  min-width: 16px;\n  margin-right: 6px;\n"]))),
    ze = p(ne || (ne = K(["\n  ", ":focus & {\n    color: currentColor;\n  }\n"])), Ie.selector);

function He(e) {
  var n,
      r,
      o,
      c = e.children,
      d = e.className,
      u = e.glyph,
      h = e.selected,
      m = e.focused,
      b = e.disabled,
      v = e.onClick,
      y = e.onFocus,
      x = e.isDeselection,
      w = e.triggerScrollIntoView,
      k = e.hasGlyphs,
      N = i(De).mode,
      S = E().usingKeyboard,
      C = ve[N].option,
      j = a(null),
      D = h && (N === be || !x),
      I = l(function () {
    if (null == j.current) return null;
    var e = j.current,
        n = null == e ? void 0 : e.offsetParent;
    if (!n) return null;
    n.scrollTop = e.offsetTop + (e.clientHeight - n.clientHeight) / 2;
  }, [j]),
      z = g(w),
      H = w && !z;
  s(function () {
    H && I();
  }, [I, H]);
  var A = g(m),
      M = m && !A;
  s(function () {
    M && j.current.focus();
  }, [M]);

  var T,
      G = _("span", {
    className: f(Pe, (n = {}, F(n, p(re || (re = K(["\n          font-weight: bold;\n        "]))), D), F(n, p(te || (te = K(["\n          font-family: ", ";\n        "])), O.legacy), N === me), n))
  }, c),
      L = _("span", {
    className: f(_e, p(oe || (oe = K(["\n          height: 100%;\n        "]))))
  }),
      R = L;

  u && (u.type.isGlyph ? R = t.cloneElement(u, {
    key: "glyph",
    className: f(_e, p(ie || (ie = K(["\n            color: ", ";\n          "])), C.icon.base), (T = {}, F(T, ze, S), F(T, p(ae || (ae = K(["\n              color: ", ";\n            "])), C.icon.disabled), b), T), u.props.className)
  }) : console.error("`Option` instance did not render icon because it is not a known glyph element."));
  var B,
      X = D ? _(P, {
    key: "checkmark",
    className: f(_e, p(le || (le = K(["\n          color: ", ";\n        "])), C.icon.selected), (r = {}, F(r, ze, S), F(r, p(se || (se = K(["\n            color: ", ";\n          "])), C.icon.disabled), b), r))
  }) : L;
  return B = k ? _("span", {
    className: p(ce || (ce = K(["\n          display: flex;\n          justify-content: space-between;\n          width: 100%;\n        "])))
  }, _("span", {
    className: p(de || (de = K(["\n            display: flex;\n          "])))
  }, R, G), X) : _(t.Fragment, null, X, G), _("li", V({}, Ie.prop, {
    role: "option",
    "aria-selected": h,
    tabIndex: -1,
    ref: j,
    className: f(Ee, p(ue || (ue = K(["\n          cursor: pointer;\n          color: ", ";\n        "])), C.text.base), (o = {}, F(o, p(pe || (pe = K(["\n            padding: 10px 12px;\n          "]))), N === me), F(o, p(fe || (fe = K(["\n            &:hover {\n              background-color: ", ";\n            }\n          "])), C.background.hovered), !b), F(o, p(ge || (ge = K(["\n            &:focus {\n              color: ", ";\n              background-color: ", ";\n\n              &:before {\n                opacity: 1;\n                transform: scaleY(1);\n                background-color: ", ";\n              }\n            }\n          "])), C.text.focused, C.background.focused, C.indicator.focused), S && !b), F(o, p(he || (he = K(["\n            cursor: not-allowed;\n            color: ", ";\n          "])), C.text.disabled), b), o), d),
    onClick: v,
    onFocus: y,
    onKeyDown: void 0
  }), B);
}

function Ae(e) {
  throw Error("`Option` must be a child of a `Select` instance");
}

He.displayName = "Option", Ae.displayName = "Option";
var Me,
    Te,
    Ge,
    Le,
    Re = u.oneOfType([u.string, u.number]);
Ae.propTypes = {
  children: u.oneOfType([Re, u.arrayOf(u.oneOfType([Re, u.oneOf([!1, null, void 0, ""])]))]).isRequired,
  className: u.string,
  glyph: u.element,
  value: u.string,
  disabled: u.bool
};
var Fe = p(Me || (Me = K(["\n  padding: 8px 0;\n"]))),
    Ve = p(Te || (Te = K(["\n  cursor: default;\n  width: 100%;\n  padding: 0 12px 2px;\n  outline: none;\n  overflow-wrap: anywhere;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n"])));

function Be(e) {
  var n = e.className,
      r = e.label,
      t = e.children,
      o = i(De).mode,
      a = ve[o].option,
      l = h({
    prefix: "select-option-group"
  });
  return _("div", {
    className: f(Fe, p(Ge || (Ge = K(["\n          border-bottom: 1px solid ", ";\n        "])), a.group.border), n)
  }, _("div", {
    id: l,
    className: f(Ve, p(Le || (Le = K(["\n            color: ", ";\n          "])), a.group.label))
  }, r), _("div", {
    role: "group",
    "aria-labelledby": l
  }, t));
}

function Ke(e) {
  throw Error("`OptionGroup` must be a child of a `Select` instance");
}

Be.displayName = "OptionGroup", Ke.displayName = "OptionGroup", Ke.propTypes = {
  children: u.oneOfType([u.element, u.arrayOf(u.oneOfType([u.oneOf([!1, null, void 0, ""]), u.element]))]).isRequired,
  className: u.string,
  label: u.string.isRequired,
  disabled: u.bool
};
var Xe = ["children"];

function Ze(e) {
  return null == e || !1 === e || "" === e;
}

function qe(e, n) {
  t.Children.forEach(e, function (e) {
    y(e, "Option") ? n(e) : y(e, "OptionGroup") ? qe(e.props.children, function (r) {
      return n(r, e);
    }) : z(e) && qe(e.props.children, n);
  });
}

function Ye(e, n, r) {
  return t.Children.toArray(e).every(function (e) {
    return y(e, "Option");
  }) || t.Children.toArray(e).every(function (e) {
    return y(e, "OptionGroup");
  }) || x.warn("LeafyGreen Select: Combining grouped and ungrouped Select Options can cause styling issues"), t.Children.map(e, function (e) {
    if (y(e, "Option")) return _(He, n(e));

    if (y(e, "OptionGroup")) {
      var t = e.props,
          o = t.children,
          i = B(t, Xe);
      return _(Be, V({
        className: void 0
      }, i), Ye(o, function (r) {
        return n(r, e);
      }, r));
    }

    return z(e) ? Ye(e.props.children, n, r) : (Ze(e) || null == r || r(e), null);
  });
}

function Ue(e) {
  return null === e ? "" : void 0 !== e.props.value ? e.props.value : Array.isArray(e.props.children) ? e.props.children.filter(function (e) {
    return !Ze(e);
  }).join("") : e.props.children.toString();
}

function We(e, n) {
  var r, t, o;
  return null !== (r = e.props.disabled) && void 0 !== r && r || null !== (t = null == n || null === (o = n.props) || void 0 === o ? void 0 : o.disabled) && void 0 !== t && t;
}

function $e(e, n, r) {
  return Ue(e) === r && !We(e, n);
}

function Je(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = n.initialValue,
      t = n.deps,
      o = void 0 === t ? [] : t,
      i = a(r);
  return c(function () {
    return {
      get current() {
        return i.current;
      },

      set current(n) {
        i.current = n, e(n);
      }

    };
  }, [e, i].concat(Z(o)));
}

function Qe(e, n) {
  var r = l(function (e, n) {
    Array.isArray(e) ? e.forEach(r) : "function" == typeof e ? e(n) : e && (e.current = n);
  }, []);
  return Je(l(function (n) {
    return r(e, n);
  }, [e, r]), {
    initialValue: n
  });
}

var en,
    nn,
    rn,
    tn,
    on,
    an = function an(e) {
  var n = X(d(e), 2),
      r = n[0];
  return Je(n[1], {
    initialValue: e,
    deps: [r]
  });
},
    ln = p(en || (en = K(["\n  position: relative;\n  text-align: left;\n  width: 100%;\n  border-radius: 3px; //\n  line-height: 16px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n"]))),
    sn = function sn(e, n) {
  var r,
      t = e === me ? we[n] : xe[n],
      o = ve[e];
  return f(p(nn || (nn = K(["\n      font-size: ", "px;\n      min-height: ", "px;\n      background-color: ", ";\n    "])), t.option.text, t.height, o.option.background.base), (F(r = {}, p(rn || (rn = K(["\n        font-family: ", ";\n        border: 1px solid ", ";\n        border-radius: 12px;\n        box-shadow: 0 4px 7px 0 ", ";\n        padding: 8px 0;\n      "])), O.default, o.menu.border, o.menu.shadow), e === be), F(r, p(tn || (tn = K(["\n        font-family: ", ";\n        border-radius: 3px;\n        box-shadow: 0 3px 7px 0 ", ";\n      "])), O.legacy, o.menu.shadow), e === me), r));
},
    cn = t.forwardRef(function (e, n) {
  var r = e.children,
      t = e.id,
      o = e.referenceElement,
      a = e.className,
      s = e.labelId,
      d = e.usePortal,
      u = void 0 === d || d,
      g = e.portalContainer,
      h = e.scrollContainer,
      b = e.portalClassName,
      v = e.popoverZIndex,
      y = i(De),
      x = y.mode,
      w = y.size,
      O = y.disabled,
      N = y.open,
      S = Qe(n, null),
      C = m(),
      E = c(function () {
    if (C && S.current && o.current) {
      var e = o.current.getBoundingClientRect(),
          n = e.top,
          r = e.bottom,
          t = Math.max(C.height - r, n);
      return Math.min(274, t - 8);
    }

    return 274;
  }, [S, o, C]),
      P = l(function (e) {
    S.current && S.current.focus(), e.stopPropagation();
  }, [S]),
      z = R({
    popoverZIndex: v
  }, u ? {
    usePortal: u,
    portalClassName: b,
    portalContainer: g,
    scrollContainer: h
  } : {
    usePortal: u
  });
  return _(j, V({
    active: N && !O,
    spacing: "dark" === x ? 4 : 8,
    align: D.Bottom,
    justify: I.Middle,
    adjustOnMutation: !0,
    className: a,
    refEl: o
  }, z), _("ul", {
    "aria-labelledby": s,
    role: "listbox",
    ref: S,
    tabIndex: -1,
    onClick: P,
    className: f(ln, sn(x, w), p(on || (on = K(["\n              max-height: ", "px;\n              @media only screen and (max-width: ", "px) {\n                font-size: ", "px;\n              }\n            "])), E, k.Desktop, Ce.text)),
    id: t
  }, r));
});

cn.displayName = "ListMenu";

var dn,
    un,
    pn,
    fn,
    gn,
    hn,
    mn,
    bn,
    vn,
    yn,
    xn,
    wn,
    On,
    kn,
    Nn,
    Sn,
    Cn,
    jn,
    Dn,
    In,
    En,
    Pn,
    _n,
    zn,
    Hn,
    An,
    Mn,
    Tn,
    Gn,
    Ln = ["children", "value", "text", "name", "deselected", "readOnly", "onClose", "onOpen", "errorMessage", "state", "__INTERNAL__menuButtonSlot__"],
    Rn = p(dn || (dn = K(["\n  text-transform: unset;\n  font-weight: 400;\n  // Override button defaults\n  > *:last-child {\n    grid-template-columns: 1fr 16px;\n    padding: 0 12px;\n    > svg {\n      justify-self: right;\n      width: 16px;\n      height: 16px;\n    }\n  }\n"]))),
    Fn = (F(fn = {}, be, p(un || (un = K(["\n    background-color: ", ";\n    // Override button default color\n    > *:last-child {\n      > svg {\n        color: ", ";\n      }\n    }\n  "])), n.white, n.gray.dark2)), F(fn, me, p(pn || (pn = K(["\n    border-color: transparent;\n  "])))), fn),
    Vn = (F(mn = {}, be, p(gn || (gn = K(["\n    color: ", ";\n  "])), ve.light.text.deselected)), F(mn, me, p(hn || (hn = K(["\n    color: ", ";\n  "])), ve.dark.text.deselected)), mn),
    Bn = (F(yn = {}, be, p(bn || (bn = K(["\n    background-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n\n    > *:last-child {\n      > svg {\n        color: ", ";\n      }\n    }\n  "])), n.gray.light2, n.gray.base, n.gray.base)), F(yn, me, p(vn || (vn = K([""])))), yn),
    Kn = p(xn || (xn = K(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-grow: 1;\n  gap: ", "px;\n"])), N[1]),
    Xn = p(wn || (wn = K(["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 100%;\n"]))),
    Zn = (F(On = {}, be, n.red.base), F(On, me, "#F97216"), On),
    qn = (F(Sn = {}, be, p(kn || (kn = K(["\n    border-color: ", ";\n    background-color: ", ";\n\n    &:hover,\n    &:active {\n      box-shadow: 0 0 0 3px #f9d5c5; // Between light2 & light3\n    }\n  "])), Zn[be], n.white)), F(Sn, me, p(Nn || (Nn = K(["\n    border-color: ", "; // off palette\n    box-shadow: 0px 1px 2px rgba(87, 11, 8, 0.3);\n\n    &:hover,\n    &:active {\n      border-color: ", "; // off palette\n      box-shadow: 0px 4px 4px rgba(87, 11, 8, 0.3),\n        0px 0px 0px 3px ", ";\n    }\n  "])), Zn[me], Zn[me], r.red.light3)), Sn),
    Yn = t.forwardRef(function (e, n) {
  var r,
      t = e.children,
      o = e.value,
      a = e.text,
      s = e.name,
      c = e.deselected;
  e.readOnly;
  var d = e.onClose,
      u = e.onOpen,
      g = e.errorMessage,
      h = e.state,
      m = e.__INTERNAL__menuButtonSlot__,
      b = B(e, Ln),
      v = i(De),
      y = v.mode,
      x = v.open,
      w = v.size,
      O = v.disabled,
      N = Qe(n, null),
      S = xe[w],
      C = l(function () {
    x ? d() : u(), N.current.focus();
  }, [d, u, x, N]),
      j = m || H,
      D = m ? "" : f(Rn, Fn[y], (F(r = {}, Vn[y], c), F(r, Bn[y], O), F(r, qn[y], h === je.Error && !!g), F(r, p(Cn || (Cn = K(["\n            letter-spacing: initial;\n          "]))), w === A.XSmall), r), p(jn || (jn = K(["\n          width: 100%;\n          @media only screen and (max-width: ", "px) {\n            height: ", "px;\n            font-size: ", "px;\n          }\n        "])), k.Desktop, Oe, ke));
  return _(j, V({}, b, {
    ref: N,
    name: s,
    value: o,
    disabled: O,
    onClick: C,
    variant: M.Default,
    darkMode: y === me,
    rightGlyph: _(T, null),
    size: w,
    "data-testid": "leafygreen-ui-select-menubutton",
    className: D
  }), _("div", {
    className: Kn
  }, _("div", {
    className: Xn
  }, a), h === je.Error && g && _(G, {
    role: "presentation",
    className: p(Dn || (Dn = K(["\n              color: ", ";\n            "])), Zn[y]),
    size: S.warningIcon
  })), t);
});

Yn.displayName = "MenuButton";

var Un = p(In || (In = K(["\n  display: flex;\n  flex-direction: column;\n"]))),
    Wn = function Wn(e) {
  var r = e.darkMode,
      t = e.sizeSet;
  return p(En || (En = K(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", "px;\n  margin-top: ", "px;\n  padding-left: 2px;\n  transition: color 100ms ease-in-out;\n  transition-delay: 100ms;\n"])), r ? O.legacy : O.default, r ? "#F97216" : n.red.base, t.text, N[1]);
};

function $n(e) {
  var n,
      r = e.children,
      t = e.darkMode,
      o = void 0 !== t && t,
      i = e.size,
      a = void 0 === i ? ye.Default : i,
      u = e.disabled,
      g = void 0 !== u && u,
      v = e.allowDeselect,
      y = void 0 === v || v,
      x = e.placeholder,
      O = void 0 === x ? "Select" : x,
      N = e.className,
      j = e.id,
      D = e.label,
      I = e["aria-labelledby"],
      E = e.description,
      P = e.name,
      z = e.defaultValue,
      H = e.value,
      A = e.onChange,
      M = e.readOnly,
      T = e.usePortal,
      G = void 0 === T || T,
      L = e.portalContainer,
      B = e.scrollContainer,
      Z = e.portalClassName,
      q = e.popoverZIndex,
      Y = e.errorMessage,
      U = void 0 === Y ? "error message right here" : Y,
      W = e.state,
      $ = void 0 === W ? je.None : W,
      J = e.__INTERNAL__menuButtonSlot__,
      Q = h({
    prefix: "select",
    id: j
  }),
      ee = c(function () {
    return null != I ? I : "".concat(Q, "-label");
  }, [I, Q]);
  D || I || console.error("For screen-reader accessibility, label or aria-labelledby must be provided to Select.");
  var ne = "".concat(Q, "-description"),
      re = "".concat(Q, "-menu"),
      te = X(d(!1), 2),
      oe = te[0],
      ie = te[1],
      ae = an(null),
      le = h({
    prefix: "select"
  }),
      se = an(null),
      ce = o ? me : be,
      de = o ? we[a] : xe[a],
      ue = c(function () {
    return {
      mode: ce,
      size: a,
      open: oe,
      disabled: g
    };
  }, [ce, a, oe, g]);
  s(function () {
    void 0 !== H && void 0 === A && !0 !== M && console.warn("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
  }, [A, M, H]);
  var pe = l(function () {
    ie(!0);
  }, []),
      fe = l(function () {
    ie(!1), ae.current.focus();
  }, [ae]);
  s(function () {
    if (oe) {
      var e = function e(_e2) {
        var n = ae.current.contains(_e2.target) || se.current.contains(_e2.target);
        ie(n);
      };

      return document.addEventListener("mousedown", e), function () {
        document.removeEventListener("mousedown", e);
      };
    }
  }, [se, ae, oe]);
  var ge = c(function () {
    var e = null;
    return void 0 === H && void 0 !== z && qe(r, function (n, r) {
      $e(n, r, z) && (e = n);
    }), e;
  }, [r, z, H]),
      he = X(d(ge), 2),
      ve = he[0],
      Oe = he[1];
  s(function () {
    var e;
    null !== ve && Oe(null !== (e = function (e, n) {
      var r, t, o, i, a, l, s, c;
      return qe(e, function (e) {
        if (e === n) a = n;else if (e.props.children === n.props.children && e.props.value === n.props.value) {
          var r;
          null !== (r = l) && void 0 !== r || (l = e);
        } else if (void 0 !== e.props.value && e.props.value === n.props.value) {
          var t;
          null !== (t = s) && void 0 !== t || (s = e);
        } else if (Ue(e) === Ue(n)) {
          var o;
          null !== (o = c) && void 0 !== o || (c = e);
        }
      }), null !== (r = null !== (t = null !== (o = null !== (i = a) && void 0 !== i ? i : l) && void 0 !== o ? o : s) && void 0 !== t ? t : c) && void 0 !== r ? r : null;
    }(r, ve)) && void 0 !== e ? e : ge);
  }, [r, ge, ve]);
  var ke = c(function () {
    if (void 0 !== H) {
      var e = null;
      return qe(r, function (n, r) {
        $e(n, r, H) && (e = n);
      }), e;
    }

    return ve;
  }, [r, ve, H]),
      Ce = l(function (e, n) {
    void 0 === H && Oe(e), null == A || A(Ue(e), n), _e(void 0), fe();
  }, [A, fe, H]),
      Ie = l(function (e, n) {
    return function (r) {
      r.preventDefault(), r.stopPropagation(), g || n || (Ce(e, r), fe());
    };
  }, [g, fe, Ce]),
      Ee = X(d(), 2),
      Pe = Ee[0],
      _e = Ee[1],
      ze = c(function () {
    var e = [];
    return y && e.push(null), qe(r, function (n, r) {
      We(n, r) || e.push(n);
    }), e;
  }, [r, y]),
      Ae = l(function (e) {
    void 0 !== Pe && Ce(Pe, e);
  }, [Pe, Ce]),
      Me = l(function () {
    _e(ze[0]);
  }, [ze]),
      Te = l(function () {
    _e(ze[ze.length - 1]);
  }, [ze]),
      Ge = l(function () {
    if (void 0 === Pe || 0 === ze.indexOf(Pe)) Te();else {
      var e = ze.indexOf(Pe) - 1;

      _e(ze[e]);
    }
  }, [ze, Pe, Te]),
      Le = l(function () {
    if (void 0 === Pe || ze.indexOf(Pe) === ze.length - 1) Me();else {
      var e = ze.indexOf(Pe) + 1;

      _e(ze[e]);
    }
  }, [ze, Pe, Me]),
      Re = l(function (e, n) {
    return function (r) {
      r.preventDefault(), r.stopPropagation(), g || n || _e(e);
    };
  }, [g]),
      Fe = l(function (e) {
    var n, r;

    if (!(e.ctrlKey || e.shiftKey || e.altKey)) {
      var t = null === (n = se.current) || void 0 === n ? void 0 : n.contains(document.activeElement),
          o = null === (r = ae.current) || void 0 === r ? void 0 : r.contains(document.activeElement);
      if (o || t) switch (e.keyCode) {
        case w.Tab:
        case w.Escape:
          fe(), _e(void 0);
          break;

        case w.Enter:
        case w.Space:
          oe && !o && e.preventDefault(), Ae(e);
          break;

        case w.ArrowUp:
          !oe && o && pe(), e.preventDefault(), Ge();
          break;

        case w.ArrowDown:
          !oe && o && pe(), e.preventDefault(), Le();
      }
    }
  }, [se, ae, fe, oe, Ae, Ge, Le, pe]);
  b("keydown", Fe);
  var Ve = m(),
      Be = c(function () {
    var e = !1;
    return qe(r, function (n) {
      e || (e = void 0 !== n.props.glyph);
    }), e;
  }, [r]),
      Ke = c(function () {
    return null !== Ve && null !== se.current && void 0 === Pe && oe;
  }, [Pe, se, oe, Ve]),
      Xe = c(function () {
    var e = null === ke;
    return _(He, {
      className: void 0,
      glyph: void 0,
      selected: e,
      focused: null === Pe,
      disabled: !1,
      onClick: Ie(null, !1),
      onFocus: Re(null, !1),
      isDeselection: !0,
      hasGlyphs: !1,
      triggerScrollIntoView: e && Ke
    }, O);
  }, [Ke, Pe, Ie, Re, O, ke]),
      Ze = c(function () {
    return Ye(r, function (e, n) {
      var r = e === ke,
          t = We(e, n);
      return {
        className: e.props.className,
        glyph: e.props.glyph,
        selected: r,
        focused: e === Pe,
        disabled: t,
        children: e.props.children,
        isDeselection: !1,
        hasGlyphs: Be,
        onClick: Ie(e, t),
        onFocus: Re(e, t),
        triggerScrollIntoView: r && Ke
      };
    }, function () {
      console.error("`Select` instance received child that is not `Option` or `OptionGroup`.");
    });
  }, [Ke, r, Pe, Ie, Re, Be, ke]),
      Je = R({
    popoverZIndex: q
  }, G ? {
    usePortal: G,
    portalClassName: Z,
    portalContainer: L,
    scrollContainer: B
  } : {
    usePortal: G
  });
  return _("div", {
    className: f(Un, N)
  }, D && _(S, {
    htmlFor: le,
    id: ee,
    darkMode: o,
    disabled: g,
    className: f(p(Pn || (Pn = K(["\n              // Prevent hover state from showing when hovering label\n              pointer-events: none;\n            "]))), p(_n || (_n = K(["\n              @media only screen and (max-width: ", "px) {\n                font-size: ", "px;\n                line-height: ", "px;\n              }\n            "])), k.Desktop, Ne.text, Ne.lineHeight), F({}, p(zn || (zn = K(["\n                font-size: ", "px;\n                line-height: ", "px;\n                padding-bottom: 0;\n                margin-bottom: 2px;\n              "])), we[a].label.text, we[a].label.lineHeight), ce === me))
  }, D), E && _(C, {
    id: ne,
    darkMode: o,
    disabled: g,
    className: f(p(Hn || (Hn = K(["\n              @media only screen and (max-width: ", "px) {\n                font-size: ", "px;\n                line-height: ", "px;\n              }\n            "])), k.Desktop, Se.text, Se.lineHeight), F({}, p(An || (An = K(["\n                font-size: ", "px;\n                line-height: ", "px;\n                padding-bottom: 0;\n                margin-bottom: 2px;\n              "])), we[a].description.text, we[a].description.lineHeight), ce === me))
  }, E), _(De.Provider, {
    value: ue
  }, _(Yn, {
    id: le,
    ref: ae,
    name: P,
    readOnly: M,
    value: Ue(ke),
    text: null !== ke ? ke.props.children : O,
    deselected: null === ke,
    onOpen: pe,
    onClose: fe,
    "aria-labelledby": ee,
    "aria-controls": re,
    "aria-expanded": oe,
    "aria-describedby": ne,
    "aria-invalid": $ === je.Error,
    errorMessage: U,
    state: $,
    __INTERNAL__menuButtonSlot__: J
  }, _(cn, V({
    labelId: ee,
    id: re,
    referenceElement: ae,
    ref: se,
    className: p(Mn || (Mn = K(["\n              width: ", "px;\n            "])), null === (n = ae.current) || void 0 === n ? void 0 : n.clientWidth)
  }, Je), y && Xe, Ze))), $ === je.Error && U && _("span", {
    className: f(Wn({
      darkMode: o,
      sizeSet: de
    }), p(Tn || (Tn = K(["\n              @media only screen and (max-width: ", "px) {\n                font-size: ", "px;\n                line-height: ", "px;\n              }\n            "])), k.Desktop, Se.text, Se.lineHeight), F({}, p(Gn || (Gn = K(["\n                // Hide error text when menu is open,\n                // so it doesn't peek around the menu corner\n                color: transparent;\n              "]))), oe))
  }, U));
}

$n.displayName = "Select", $n.propTypes = {
  label: u.string,
  "aria-labelledby": u.string,
  description: u.string,
  placeholder: u.string,
  className: u.string,
  darkMode: u.bool,
  size: u.oneOf(Object.values(ye)),
  disabled: u.bool,
  id: u.string,
  value: u.string,
  defaultValue: u.string,
  onChange: u.func,
  readOnly: u.bool,
  errorMessage: u.string,
  state: u.oneOf(Object.values(je))
};
export { Ae as Option, Ke as OptionGroup, $n as Select, ye as Size, je as State };